'use client';

import React, { createContext, useContext } from 'react';
import { DashboardPromptId } from '../app/_lib/backend/aiContext/ids';

export type DashboardPromptsContextProps = {
  /** Eligible prompt ids, already filtered and capped by the server*/
  promptIds: DashboardPromptId[];
  /** Raw interpolation values per prompt id, computed server-side. */
  promptValues: Partial<Record<DashboardPromptId, Record<string, string>>>;
};

const DashboardPromptsContext = createContext<DashboardPromptsContextProps>({
  promptIds: [],
  promptValues: {},
});

/**
 * Hook to access the dashboard example prompt chip ids computed server-side.
 */
export const useDashboardPrompts = (): DashboardPromptsContextProps =>
  useContext(DashboardPromptsContext);

/**
 * Delivers the server-computed dashboard prompt ids to the chip
 */
export const DashboardPromptsProvider = ({
  promptIds,
  promptValues,
  children,
}: DashboardPromptsContextProps & { children: React.ReactNode }) => (
  <DashboardPromptsContext.Provider value={{ promptIds, promptValues }}>
    {children}
  </DashboardPromptsContext.Provider>
);
